import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  shortText: PropTypes.string,
  fullText: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  mod: PropTypes.string,
};

const LoanPurposeItem = (props) => {
  const {
    input,
    meta: { touched, error },
    shortText,
    fullText,
    disabled,
    className,
    mod,
  } = props;
  const inputClasses = cx({
    'loan-purpose-item': true,
    'loan-purpose-item--state-error': touched && error,
    'loan-purpose-item--state-disabled': disabled,
    'loan-purpose-item--state-selected': input.value,
    [className]: className,
    [`loan-purpose-item--mod-${mod}`]: mod,
  });
  return (
    <label className={inputClasses}>
      <span className="loan-purpose-item__title">
        {shortText}
      </span>
      <span className="loan-purpose-item__icon" />
      <input
        {...input}
        type="checkbox"
        className="loan-purpose-item__input"
        value={fullText}
        checked={input.value}
        disabled={disabled}
      />
    </label>
  );
};

LoanPurposeItem.propTypes = propTypes;

export default LoanPurposeItem;
